package com.macrofocus.eflux.ui

enum class Border {
    North,
    South,
    East,
    West
}